
import { useEffect, useState } from "react";
import riderService from 'src/services/riderService';
import ConfirmDialog from "./ConfirmDialog";

export default function RiderDocument({ documentId, isOpen, onClose }) {

    // const { documentId } = router.query;
    const [riderDocument, setRiderDocument] = useState();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isValidDocument, setIsValidDocument] = useState();
    const [successMessage, setSuccessMessage] = useState();
    const openDialog = () => {
        setIsDialogOpen(!isDialogOpen);
    };
    useEffect(() => {
        riderService.getRiderDocument(documentId)
        .then((res) => {
            if (res.status == 200) {
                setRiderDocument(res.data);
            }
        })
    }, [])

    const updateVerified = (isValidDocument) => {
        setIsValidDocument(isValidDocument);
        setIsDialogOpen(!isDialogOpen);
    }

    const clickedYes = () => {
        updateService();

    }

    const clickedNo = () => {
        setIsDialogOpen(false);
    }

    const updateService = () => {
        riderService.updateRiderDocument(documentId, isValidDocument).then((res) => {
            if (res.status == 200) {
                setSuccessMessage(res.data.message);
                window.location.reload();
            }
        })
    }
    return (

        <div className={`fixed inset-0 ${isOpen ? 'block' : 'hidden'}`}>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="absolute inset-0 flex items-center justify-center">

                <div className="bg-white p-6 rounded-lg shadow-lg max-h-full overflow-y-auto w-96">

                    {successMessage ?
                        <>
                            <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4" role="alert">
                                <p className="font-bold">Success!</p>
                                <p>Your operation was successful.</p>
                            </div>
                        </> :
                        <>
                        </>

                    }
                    {riderDocument ? (
                        <div className="flex justify-center">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-auto ">
                                <div className="mb-4 text-gray-600">
                                    <div className="flex flex-col items-center justify-center mb-4">

                                        {riderDocument.vehicle_number != null ? (
                                            <div className="text-black text-3xl">
                                                <div className="mb-2 mt-10">
                                                    Vehicle Number<br /><strong className="text-3xl">{riderDocument.vehicle_number}</strong>
                                                </div>

                                            </div>
                                        ) : (
                                            <div className="text-green-500">


                                            </div>
                                        )}
                                    </div>
                                    <div className="max-w-xs mx-auto">
                                        <div className="mb-2">
                                            <strong>Document Image</strong>
                                        </div>
                                        {riderDocument.license_front_page_image_url ? (
                                            <img src={riderDocument.license_front_page_image_url} className="w-full h-auto" />
                                        ) : (
                                            <div className="bg-gray-300 w-full h-64 flex items-center justify-center">
                                                No Image Available
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex flex-col items-center justify-center mb-4">

                                        <div className="mb-2">
                                            <strong>Is Document Verified</strong>
                                        </div>
                                        {riderDocument.is_valid_document === 0 ? (
                                            <div className="text-red-500">
                                                <img
                                                    src="/assets/images/delete-button.png"
                                                    alt="Not Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-red-500"
                                                />
                                                <p className="mt-2">Not Verified</p>
                                            </div>
                                        ) : (
                                            <div className="text-green-500">
                                                <img
                                                    src={"/assets/images/approved.png"}
                                                    alt="Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-blue-500"
                                                />
                                                <p className="mt-2">Verified</p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex flex-col items-center justify-center mb-4">

                                        {riderDocument.is_valid_document === 0 ? (
                                            <div className="text-red-500">
                                                <button className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
                                                    onClick={() => updateVerified(true)}
                                                >
                                                    Change to verified
                                                </button>

                                            </div>
                                        ) : (
                                            <div className="text-green-500">
                                                <button className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
                                                    onClick={() => updateVerified(false)}
                                                >
                                                    Change to Not verified
                                                </button>

                                            </div>
                                        )}
                                    </div>
                                    <button
                                        onClick={onClose}
                                        className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                    >
                                        Close
                                    </button>
                                </div>

                            </div>
                            <ConfirmDialog
                                isOpen={isDialogOpen}
                                onYes={clickedYes}
                                onNo={clickedNo}
                            />

                        </div>

                    ) : (
                        <>
                        </>
                    )}


                </div>
            </div>
        </div>
    );
}

// export async function getServerSideProps(context) {
//     const { riderId } = context.query;

//     return {
//         props: {
//             riderId: riderId || null, // Handle the case where id is undefined
//         },
//     };
// }